import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { RotateLeft } from '@sorare/core/src/atoms/icons/RotateLeft';
import { Vault } from '@sorare/core/src/atoms/icons/Vault';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { glossary } from '@sorare/core/src/lib/glossary';

import type { TokenSealingFooter_anyCard } from './__generated__/index.graphql.ts';

type Props = {
  anyCard: TokenSealingFooter_anyCard;
  selected?: boolean;
  onSelect?: () => void;
};

export const TokenSealingFooter = ({
  anyCard,
  selected = false,
  onSelect,
}: Props) => {
  const { sealableFor, sealed } = anyCard;

  if (sealed) {
    return null;
  }

  if (selected) {
    return (
      <Button size="small" color="quaternary" onClick={onSelect}>
        <RotateLeft />
        <FormattedMessage {...glossary.undo} />
        <span>({sealableFor})</span>
      </Button>
    );
  }

  return (
    <Button size="small" color="quaternary" onClick={onSelect}>
      <Vault size={2} action="vault" />
      <Horizontal>{sealableFor}</Horizontal>
    </Button>
  );
};

TokenSealingFooter.fragments = {
  anyCard: gql`
    fragment TokenSealingFooter_anyCard on AnyCardInterface {
      slug
      sealed
      sealableFor
    }
  ` as TypedDocumentNode<TokenSealingFooter_anyCard>,
};
